import React from 'react';
import { Button, Dialog } from '@economic/taco';
import { Trans } from '@lingui/macro';
import { PartialInvoiceDto } from '~/types/internal-api';
import { SalesDocument } from '../../types';
import ExistingPartialInvoicesInfo from './ExistingPartialInvoicesInfo';

interface Props {
    close: () => void;
    order: SalesDocument;
    partialInvoices: PartialInvoiceDto[];
}

export default function ViewPartialInvoices({ close, order, partialInvoices }: Props) {
    return (
        <>
            <Dialog.Title className="mb-6">
                <Trans>Partial invoice</Trans>
            </Dialog.Title>
            <ExistingPartialInvoicesInfo
                openedInCreatePartialInvoiceDialog={false}
                order={order}
                partialInvoices={partialInvoices}
            />
            <Dialog.Footer>
                <Button appearance="primary" onClick={close}>
                    <Trans>OK</Trans>
                </Button>
            </Dialog.Footer>
        </>
    );
}
